import React, { Component } from "react";
import Page from '../../Page';
import DocumentMeta from 'react-document-meta';
import fullimageImage from '../../img/Screenshot2020-07-3121.25.42-min.png';
import TextFullImage from "../../components/TextFullImage/TextFullImage";
import IntroHome from "../../components/IntroHome/IntroHome";
import PageNumber from "../../components/PageNumber/PageNumber";
import Share from "../../components/Share/Share";
import MetaTags from "react-meta-tags";

const title = "Welkom bij het </br> vernieuwde Appart Me";
const paragraphs1 = [
  "In maart leek het erop dat we een groot rood kruis door het jaar 2020 konden zetten. Ineens waren we aan ons thuiskantoor genageld en leken onze relaties mijlenver weg. Toch is het ons, samen met onze relaties, gelukt om deze vreemde periode om te zetten in iets positiefs. We hebben veel uren en kilometers in de auto bespaard en hebben juist vaker met elkaar kunnen schakelen via de digitale snelweg. We hebben een periode van afstand omgezet in een periode van verbinding en daar zijn we jullie dankbaar voor.",
  "Met onze vertrouwde Appart Me-krant varen we mee op diezelfde golf van vernieuwing en verbinding. Acht edities lang hebben we door middel van een gedrukte editie relaties aan elkaar gekoppeld en interessante achtergrondverhalen uit ons netwerk een podium gegeven. Daar willen we graag mee doorgaan, maar dan wel met de inzichten van nu.",
  "Appart Me gaat daarom digitaal verder! De eerste digitale editie zie je nu voor je, inclusief de kenmerkende gesprekken met onze relaties, exclusief het milieubelastende drukwerk en de vele kilometers in de auto om de krant te bezorgen. Het bleek in deze coronacrisis onmogelijk om de papieren versie met een persoonlijke handdruk bij al onze relaties af te geven, terwijl dat voor ons juist de toegevoegde waarde was. Daarom hebben de transformatie naar een online platform versneld ingezet.",
  "In deze editie lees je de ondernemersverhalen van zeven van onze zeer gewaardeerde relaties. Stuk voor stuk vertellen zij op een inspirerende manier hoe zij hun bedrijf runnen en waar zij kansen voor de toekomst zien. Verder duiken wij dieper in de wereld van SPACE32, onze nieuwe innovatiehub die we samen met onze partners van Service Bureau Jansen (SBJ) op de High Tech Campus in Eindhoven runnen. Paul Cremers en Bart Jansen vertellen over het ontstaan van de samenwerking en vragen ontwerper Jen Ditters naar de gedachte achter het vooruitstrevende logo.",
  "In de toekomst blijven we Appart Me verder uitbouwen naar een (h)echte online community. Wil je zelf een bijdrage leveren aan ons nieuwe online magazine of heb je een interessant verhaal dat je binnen ons netwerk wilt delen? We nodigen je van harte uit! Neem contact op via <a href='mailto:info@appart.nl'>info@appart.nl</a> en we zijn één en al oor.",
  "Veel leesplezier!"
];

class Firstpage extends Component {
  componentDidMount(){
    const prevLink = '/appart-me/editie-9/';
    const nextLink = '/appart-me/editie-9/overzicht-editie-9';
    const prevPossible = false;
    const nextPossible = true;
    const isScrollable = false;
    this.props.updatelinks(prevLink, nextLink, prevPossible, nextPossible, isScrollable);
  }
 render() {
  return (
   <Page>
     <MetaTags>
       <title>Appart Me | Cover Editie 9</title>
       <meta name="description" content="Welkom bij het vernieuwde Appart Me" />
       <meta name="og:title" content="Welkom bij het vernieuwde Appart Me" />
       <meta name="og:description" content="Welkom bij het vernieuwde Appart Me" />
       <meta name="og:image" content={"https://appart.nl/" + fullimageImage} />
       <meta name="twitter:image" content={"https://appart.nl/" + fullimageImage} />
     </MetaTags>
     <IntroHome background={fullimageImage} noOverlay="true" />
     <TextFullImage title={title} paragraphs={paragraphs1} image={fullimageImage} alt="papegaai"/>
     <Share />
     <PageNumber pageNumber={1} />
   </Page>
  )
 }
}

export default Firstpage;
